import login from '@/views/users/login.vue'

export default [
  {
    path: '/login',
    name: 'Login',
    component: login
  }
]
